module.exports = __webpack_public_path__ + "img/isp-high.06d0e65d.png";